"use client";

import { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const filters = [
  {
    id: "state",
    name: "State",
    options: [
      "Andhra Pradesh",
      "Arunachal Pradesh",
      "Assam",
      "Bihar",
      "Chandigarh",
      "Chhattisgarh",
      "Delhi",
      "Goa",
      "Gujarat",
      "Haryana",
      "Himachal Pradesh",
      "Jharkhand",
      "Karnataka",
      "Kerala",
      "Madhya Pradesh",
      "Maharashtra",
      "Manipur",
      "Meghalaya",
      "Mizoram",
      "Nagaland",
      "Odisha",
      "Punjab",
      "Rajasthan",
      "Sikkim",
      "Tamil Nadu",
      "Telangana",
      "Tripura",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal",
    ],
  },
  {
    id: "fabricationCategory",
    name: "Fabrication Category",
    options: [
      "Welding Machine",
      "Paint Compressor Machine",
      "CNC Router Machine",
      "Acrylic Laser Cutting Machine",
      "Channel Letter Bending Machine",
    ],
  },
  {
    id: "printCategory",
    name: "Printing Category",
    options: [
      "Ecosolvent Printing",
      "UV Printing",
      "Digital Printing",
      "Solvent Printing",
      "Plotter Cutting Printing",
      "Latex Printing",
    ],
  },
  {
    id: "ageofmachine",
    name: "Age of machine",
    options: ["0-4", "4+"],
  },
];

export default function Machine() {
  const serverURL = process.env.REACT_APP_URL;

  const [totalmachinecount, setTotalMachineCount] = useState(0);
  const [fabricationmachinecount, setFabricationMachineCount] = useState(0);
  const [printingmachinecount, setPrintingMachineCount] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleCheckboxChange = (sectionId, option, checked) => {
    console.log(sectionId, "Sectionid");
    console.log(option, "option");
    console.log(checked, "checked");
    setSelectedFilters((prev) => {
      const updated = { ...prev };
      const currentOptions = new Set(prev[sectionId] || []);

      if (checked) {
        currentOptions.add(option);
      } else {
        currentOptions.delete(option);
      }

      updated[sectionId] = Array.from(currentOptions);
      fetchFilteredData(updated); // Call GET API

      return updated;
    });
  };
  useEffect(() => {
    // Initial fetch with no filters or default filters
    fetchFilteredData({});
  }, []);

  const fetchFilteredData = async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, values]) => {
      values.forEach((val) => {
        params.append(key, val);
      });
    });

    const url = `${serverURL}/api/machineFilters?${params.toString()}`;
    console.log("GET request URL:", url);

    try {
      const response = await fetch(url);
      const data = await response.json();
      console.log("API Response:", data);
      setFabricationMachineCount(data.totalFabricationMachineCount);
      setPrintingMachineCount(data.totalPrintingMachineCount);
      setTotalMachineCount(
        data.totalFabricationMachineCount + data.totalPrintingMachineCount
      );
    } catch (error) {
      console.error("API error:", error);
    }
  };

  return (
    <div className="bg-white">
      <main className="mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid lg:grid-cols-4 gap-x-8 gap-y-10">
          <div className="hidden lg:block">
            <div className="space-y-4">
              {filters.map((section) => (
                <Accordion key={section.id}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className="font-medium">
                      {section.name}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="flex flex-col gap-2">
                      {section.options.map((opt) => (
                        <FormControlLabel
                          key={opt}
                          control={
                            <Checkbox
                              checked={
                                selectedFilters[section.id]?.includes(opt) ||
                                false
                              }
                              onChange={(e) =>
                                handleCheckboxChange(
                                  section.id,
                                  opt,
                                  e.target.checked
                                )
                              }
                            />
                          }
                          label={opt}
                        />
                      ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="border-2 border-dashed border-gray-300 py-20 flex justify-center items-center text-gray-400 h-96">
              <div className="flex justify-center items-center gap-8 py-6 ">
                <div className="text-center px-6 py-4 bg-white rounded-lg shadow-md border border-gray-200">
                  <h3 className="text-lg font-semibold text-blue-600">
                    Fabrication Machines
                  </h3>
                  <p className="text-2xl font-bold text-gray-800">
                    {fabricationmachinecount}
                  </p>
                </div>
                <div className="text-center px-6 py-4 bg-white rounded-lg shadow-md border border-gray-200">
                  <h3 className="text-3xl font-semibold text-green-600">
                    Total Machines
                  </h3>
                  <p className="text-3xl font-bold text-gray-800">
                    {totalmachinecount}
                  </p>
                </div>
                <div className="text-center px-6 py-4 bg-white rounded-lg shadow-md border border-gray-200">
                  <h3 className="text-lg font-semibold text-purple-600">
                    Printing Machines
                  </h3>
                  <p className="text-2xl font-bold text-gray-800">
                    {printingmachinecount}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
